import { render, staticRenderFns } from "./QuotationKPI.vue?vue&type=template&id=40226258&scoped=true&"
import script from "./QuotationKPI.vue?vue&type=script&lang=js&"
export * from "./QuotationKPI.vue?vue&type=script&lang=js&"
import style0 from "./QuotationKPI.vue?vue&type=style&index=0&id=40226258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40226258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40226258')) {
      api.createRecord('40226258', component.options)
    } else {
      api.reload('40226258', component.options)
    }
    module.hot.accept("./QuotationKPI.vue?vue&type=template&id=40226258&scoped=true&", function () {
      api.rerender('40226258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/companies/QuotationKPI.vue"
export default component.exports